import SessionJoinDialog from './SessionJoinDialog';

export default SessionJoinDialog;
